import { render, staticRenderFns } from "./pollRecord.vue?vue&type=template&id=3b58ba49&scoped=true&"
import script from "./pollRecord.vue?vue&type=script&lang=js&"
export * from "./pollRecord.vue?vue&type=script&lang=js&"
import style0 from "./pollRecord.vue?vue&type=style&index=0&id=3b58ba49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b58ba49",
  null
  
)

export default component.exports